import React from 'react';
import { option } from 'fp-ts';

import { Attribute, getAttributeSelectedSwatchOptionLabel } from '../../types/attributes';
import { wrapInputId, deSnake, filterNotEmpty } from '../../helpers/strings';
import { getDangerousHtml } from '../../helpers/components';

export type $defaultInputProps = {
  value: String,
  onChange: ?Function,
  name: String,
  ref: Function,
}

export const InputError = error => <span className="pdp-form__field--error-label">{error}</span>;

const InputCreator = (renderFn: Function) => ({ renderLabel = null, ...props }) => {
  const {
    attribute,
    onMouseEnter,
    onMouseLeave,
    setAttributeValue,
  } = props;

  const defaultInputProps = {
    value: option.fromNullable(attribute.value).getOrElseValue(''),
    attribute,
    onChange: props.onInputChange,
    name: attribute.id,
  };

  const fieldClassName = `pdp-form__field ${attribute.error && attribute.error !== '' ? 'pdp-form__field--error' : ''} ${attribute.alignment && attribute.alignment !== '' ? `pdp-form__field--align-${attribute.alignment}` : ''}`;

  return (
    <div className={fieldClassName}>
      {
        typeof renderLabel === 'function'
          ? renderLabel(attribute)
          : (
            <label
              htmlFor={wrapInputId(attribute.id)}
              className="pdp-form__field-label"
            >
              <span className={`${attribute.required ? 'pdp-form__field--required' : ''}`}>
                {option.fromNullable(attribute.display_name).filter(filterNotEmpty).getOrElseValue(deSnake(attribute.label))}
              </span>

              {
                getAttributeSelectedSwatchOptionLabel(Attribute(attribute))
                  .map(label => (
                    <span className="pdp-form__field-label__value" dangerouslySetInnerHTML={getDangerousHtml(label)} />
                  ))
                  .toNullable()
              }
            </label>
          )
      }
      {
        renderFn({
          defaultInputProps,
          attribute,
          setAttributeValue,
          onMouseEnter,
          onMouseLeave,
          ...props,
        })
      }
      {
        option
          .fromNullable(attribute.error)
          .map(InputError)
          .getOrElseValue(null)
      }
    </div>
  );
};

export default InputCreator;



// WEBPACK FOOTER //
// ./src/containers/ProductForm/InputCreator.js